export default __webpack_public_path__ + "static/media/DNo.13-4.0c16ce98.jpg";